/** Max number of live items will be displayed */
export const LIVE_COUNT_MAX = 12;
